import type {
  ExternalProjectImportError,
  ExternalProjectImportPreview,
} from '@provision/entity-types';
import { createContext, useContext } from 'react';

export interface PortalioImportContextValue {
  importProjects: (projectIds: number[]) => Promise<void>;
  importing: boolean;
  records: ExternalProjectImportPreview[];
  errors?: ExternalProjectImportError<string | number>[];
  /** Closes the modal and opens the imported site. */
  openSite: (addressId: string) => void;
  close: () => void;
}

// Steps are pushed as elements whose props are fixed at push time, so they read the import from here.
export const PortalioImportContext = createContext<PortalioImportContextValue | null>(null);

export const usePortalioImport = () => {
  const value = useContext(PortalioImportContext);
  if (!value) {
    throw new Error('usePortalioImport must be used inside ImportPortalioProjectModal');
  }
  return value;
};

/** What the completed step hands back so Import more returns to the selection. */
export const IMPORT_MORE = 'import-more';
